import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function CustomSoftwareDevelopmentPage() {
  return <ServiceDetailLayout slug="custom-software-development" />;
}
